export default "{\r\n  \r\n}"